import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import UserProvider from "./context/UserContext";
import Restock from "./pages/Restock";
import {ErrorPage} from  "./pages/Error";
import './main.css'
import 'bootstrap/dist/css/bootstrap.min.css';

const urlquery = window.location.search;
const urlParams = new URLSearchParams(urlquery);
var redirectUrl

if (urlParams !== null){
  redirectUrl = '/?'+urlParams
}
else{
  redirectUrl = '/'
}

export default function App(){
  return (
      <UserProvider>
      <Router>
        <Switch>
          <Route exact path="/" component={Restock} />
          <Route exact path="/error_auth" component={ErrorPage} />
          <Route>
            <Redirect to={redirectUrl}/>
          </Route>
          </Switch>
      </Router>
      </UserProvider>
  );
};

